import { defineStore } from 'pinia';
import { strapi } from '~/stores/transport/strapi';
import { assignDataToFields } from '~/utils/strapiComponents/addStrapiData';

export const useStoreModalCashier = defineStore('modalCashier', {
  state: () => ({
    header: '',
    locale: '',
    requestPromise: null as Promise<any> | null,
  }),

  actions: {
    async loadCashierModal() {
      if (!this.requestPromise) {
        this.requestPromise = strapi()
          .get('cashier-modal')
          .finally(() => (this.requestPromise = null));
      }

      const response = await this.requestPromise;

      if (response?.data) {
        assignDataToFields(this, response.data);

        return true;
      } else {
        return false;
      }
    },
  },
});
